import vue from 'vue';
import vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './store';

vue.use(vuex);
export default new vuex.Store({
  actions,
  mutations,
  getters,
  state
});



// WEBPACK FOOTER //
// ./src/store/index.js